import React, { useRef, useState, useEffect } from "react";
import { Link, navigate } from "gatsby";
import MenuRoundedIcon from "@material-ui/icons/MenuRounded";
import "./Nav.css";
import { Link as LinkScroll } from "react-scroll";

const Nav = ({ home }) => {
  const [display, setDisplay] = useState(false);
  const [showNav, handleShow] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        handleShow(true);
      } else handleShow(false);
    });
    return () => {
      window.removeEventListener("scroll", () => {});
    };
  }, []);

  const show = useRef(null);
  function handleNav() {
    if (display === false) {
      if (show.current !== null) {
        show.current.style.top = "0";
        setDisplay(true);
      }
    } else {
      if (show.current !== null) {
        show.current.style.top = "-100%";
        setDisplay(false);
      }
    }
  }
  return (
    <div className={`navBar ${showNav && "showNav"}`}>
      <div className="navBar__logo">
        <img
          src={require("../LandingPage/Assests/Logo.png")}
          alt="Logo"
          onClick={() => navigate("/")}
        />
      </div>

      <nav className="navBar__nav" ref={show} onClick={handleNav}>
        {home ? (
          <LinkScroll
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="home"
            onClick={handleNav}
          >
            home
          </LinkScroll>
        ) : (
          <Link
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="/"
            onClick={handleNav}
          >
            home
          </Link>
        )}

        {home ? (
          <LinkScroll
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="aboutus"
            onClick={handleNav}
          >
            about us
          </LinkScroll>
        ) : (
          <Link
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="/#aboutus"
            onClick={handleNav}
          >
            about us
          </Link>
        )}

        {home ? (
          <LinkScroll
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="services"
            onClick={handleNav}
          >
            services
          </LinkScroll>
        ) : (
          <Link
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="/#services"
            onClick={handleNav}
          >
            services
          </Link>
        )}

        {/* <LinkScroll
          className="navBar__nav__link"
          smooth={true}
          duration={1000}
          to="team"
          onClick={handleNav}
        >
          team
        </LinkScroll>
        <LinkScroll
          className="navBar__nav__link"
          smooth={true}
          duration={1000}
          to="testimonial"
          onClick={handleNav}
        >
          testimonials
        </LinkScroll> */}

        {home ? (
          <LinkScroll
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="contactus"
            onClick={handleNav}
          >
            contact
          </LinkScroll>
        ) : (
          <Link
            className="navBar__nav__link"
            smooth={true}
            duration={1000}
            to="/#contactus"
            onClick={handleNav}
          >
            contact
          </Link>
        )}

        {/* <Link className="navBar__nav__link" to="/blogs" onClick={handleNav}>
          Blog
        </Link> */}
        <button
          className="navBar__nav__link"
          onClick={() => {
            handleNav();
            navigate(
              "https://enviary.com/get-free-klaviyo-audit?utm_source=header-menu-button&utm_medium=Header%20Menu%20Button&utm_campaign=Enviary's%20Internal%20Clicks%20Tracking&utm_term=enviary&utm_content=get-free-klaviyo-audit-opt-in-page"
            );
          }}
        >
          Get Free Klaviyo Audit
        </button>
      </nav>
      <div className="navBar__menu">
        <MenuRoundedIcon onClick={handleNav} />
      </div>
    </div>
  );
};

export default Nav;
